import React from "react";

// components
import Navbar from "../components/navbar/Navbar";
import TeamHeader from "../components/team/TeamHeader";
import Team from "../components/team/Team";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const TeamWrapper = () => {
  return (
    <>
      {/* <Navbar /> */}
      <TeamHeader />
      <Team />
      <PreFooter />
      <Footer />
    </>
  );
};

export default TeamWrapper;
